import { auth_client } from '../index';

const self = {

    async paginate(page: number){

        const response = await auth_client.get(`/telegram/users?page=${page}`);
        return response.data;

    }
   
}

export default self;
